module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-teatopics-04.ea25e799.jpg";